import React, { Component } from 'react';
import ConfiguratorSection from './../ConfiguratorSection';
import ConfiguratorImage from './../ConfiguratorImage';
import ConfiguratorOption from './../ConfiguratorOption';
import RadioGroup from './../RadioGroup';
import { withTranslation, Trans } from 'react-i18next';
import { exterior_view02ImageOptions } from './views/exterior_view02'

class Xc47BowSprit extends Component {
    constructor(props) {
        super(props);
        this.handleBowspritChange = this.handleBowspritChange.bind(this);
    }


    handleBowspritChange(newValue) {
        let configuration = this.props.configuration;
        configuration.BowSprit = newValue;

        if (this.props.onChange) {
            this.props.onChange(configuration);
        }
    }

    render() {
        let imageOptions = exterior_view02ImageOptions;

        let image = <ConfiguratorImage boat="Xc47" configuration={this.props.configuration} options={imageOptions} />;
        
        return (
            <ConfiguratorSection image={image}>
                
                <ConfiguratorOption>
                    <h1><Trans defaults='INTEGRATED BOWSPRIT' /></h1>

                    <p><Trans defaults='The Xc47 has an integrated composite bow sprit as standard, providing attachment point for asymmetric spinnakers. The innovative stem design in the hull allows the code-0 and forestay furler to be positioned further forward, maximising J length, and increasing upwind performance.' /></p>

                    <RadioGroup options={this.props.bowSpritOptions} value={this.props.configuration.BowSprit} onChange={this.handleBowspritChange} />
                </ConfiguratorOption>
            </ConfiguratorSection>
        );
    }
}

export default withTranslation()(Xc47BowSprit);


// WEBPACK FOOTER //
// ./src/Xc47/Xc47BowSprit.js